var r = "-ms-", a = "-moz-", v = "-webkit-", E = "comm", e = "rule", m = "decl", M = "@import", R = "@keyframes", T = "@layer";
export {
  E as COMMENT,
  m as DECLARATION,
  M as IMPORT,
  R as KEYFRAMES,
  T as LAYER,
  a as MOZ,
  r as MS,
  e as RULESET,
  v as WEBKIT
};
